export default "__VITE_ASSET__CauWlmvO__"